export default __webpack_public_path__ + "static/media/online-payment.1f7acc3d.png";